import React from "react";
import Wrapper from "../assets/wrappers/Hero";
import Form from "./Form";
import { useAppContext } from "../AppProvider";

const Hero = () => {
  const { open, setOpen } = useAppContext();
  return (
    <>
      <Wrapper name="home">
        <div className="container" data-aos="fade-in">
          <div className="center">
            {/* <span className="uppertext">
            <Typed
              strings={["Fast and Trusted Arabic Translations"]}
              typeSpeed={50}
            />
          </span> */}
            <h2>
              Recover Faster with Expert{" "}
              <span className="colorfull"> Physical Therapy </span> & Rehabilitation Services.
            </h2>
            <p style={{
              fontSize: "1.1rem",
              color: "#ffd700",
              fontWeight: "600",
              marginBottom: "15px",
              letterSpacing: "0.5px"
            }}>
              Doctor of Physical Therapy | Saint Joseph University of Beirut
            </p>
            <p style={{
              marginBottom: "20px",
              fontSize: "1.2rem",
              color: "#f1f1f1",
              lineHeight: "1.6",
              maxWidth: "100%"
            }} className="hero-description">
              Dr. Paul Abi Aad, DPT - Providing personalized care for sports injuries, post-surgical rehabilitation, and chronic pain management.
            </p>

            <button className="btn" onClick={() => setOpen(true)}>
              Book Appointment
            </button>
          </div>
        </div>
        <a href="https://wa.me/96179459354" className="whatsapp-icon" target="_blank" rel="noopener noreferrer">
          <svg viewBox="0 0 448 512" width="30" height="30">
            <path fill="currentColor" d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.1 0-65.6-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-5.5-2.8-23.2-8.5-44.2-27.3-16.3-14.6-27.4-32.6-30.5-37.8-3.3-5.5-.3-8.5 2.5-11.2 2.5-2.4 5.5-6.5 8.3-9.7 2.8-3.3 3.7-5.5 5.5-9.3.8-3.7-.8-6.9-1.9-9.7-1.1-2.8-10.6-25.5-14.6-35.1-3.9-9.4-7.8-8.1-10.6-8.2-2.7-.1-5.9-.1-9-.1s-8.1 1.2-12.4 5.9c-4.3 4.7-16.6 16.3-16.6 39.6s17 45.9 19.3 49c2.3 3.2 33.4 51.1 81 71.5 11.3 4.8 20.2 7.6 27.1 9.8 11.4 3.6 21.8 3.1 30 1.9 9.1-1.4 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
          </svg>
        </a>
        {open && <Form setOpen={setOpen} />}
      </Wrapper>
    </>
  );
};

export default Hero;
